import { DettaglioInfoProcessoDashboardDto } from '@desio/api';
import React from 'react';
import { Button, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

export interface DashboardCardProps {
  title: string
  subtitle: string
  details?: DettaglioInfoProcessoDashboardDto
  showDetails?: boolean
  callback?: () => void
  callbackLink?: string
  infoText?: string
}

/**
 * MyCard
 * 
 * It shows the info of an KPI
 * 
 * @property {string} title - title of the card
 * @property {string} subtitle - subtitle of the card
 * @property {string} callback - [optional] callback method
 * @property {string} callbackLink - [optional] callback text for link
 * @property {string} infoText - [optional] tooltip content
 * 
 * @returns JSX.Element
 */

const DashboardCard: React.FC<DashboardCardProps> = (props: DashboardCardProps) => {

  const {
    title,
    subtitle,
    details,
    showDetails = false,
    callback,
    callbackLink,
    infoText
  } = props;

  return (
    <Card style={{ height: '100%' }}>
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">
          <b>{subtitle}</b>
          {infoText && (
            <OverlayTrigger
              placement={'auto'}
              overlay={
                <Tooltip id="tooltip-card">
                  {infoText}
                </Tooltip>
              }>
              {({ ref, ...triggerHandler }) => (
                <i ref={ref} {...triggerHandler} className="fas fa-info-circle pl-2" />
              )}
            </OverlayTrigger>
          )}
        </Card.Subtitle>
        {showDetails && (
          <ul>
            <li>di cui sincrona: {details?.numeroProcessiSincrono || '0'} ({details?.percProcessiSincrono || '0'}%)</li>
            <li>di cui asincrona: {details?.numeroProcessiAsincrono || '0'} ({details?.percProcessiAsincrono || '0'}%)</li>
            <li>di cui campagne: {details?.numeroProcessiCampagna || '0'} ({details?.percProcessiCampagna || '0'}%)</li>
          </ul>
        )}
        {showDetails && callback && callbackLink && (
          <Button variant="link" onClick={callback} className="pl-0 pr-0">
            {callbackLink}
          </Button>
        )}
      </Card.Body>
    </Card>
  )
}

export default DashboardCard;
